export default "__VITE_ASSET__ClUTOmj3__"